export default "__VITE_ASSET__f2b07911__"